import { SortDirection } from "../../../../../api/src/_core/utils/utils.paging";
import { sortBy } from 'lodash';

export function arrayMove(arr, oldIndex, newIndex) {
	console.log(arr, oldIndex, newIndex);
	if (newIndex >= arr.length) {
		let k = newIndex - arr.length + 1;
		while (k--) {
			arr.push(undefined);
		}
	}
	arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
	return arr;
}

export function pluckFirst(arr: any[]) {
	if (arr && arr.length > 0) {
		return arr[0];
	} else {
		return undefined;
	}
}

export function sortArray(array: any[], id: string, direction: string) {
	if (id) {
		array = sortBy(array, id);

		if (direction === SortDirection.DESC) {
			array = array.reverse();
		}
	}
	return array;
}


export function sortArrayByAlpha(array: any[], direction?: string): any[] {
	array =  sortBy(array, (item) => item?.toLowerCase());

	if (direction === SortDirection.DESC) {
		return array.reverse();
	}

	return array;

}

export function insertAtIndex(arr: any[], index: number, item: any) {
	return [
		...arr.slice(0, index),
		item,
		...arr.slice(index)
	];
}
